var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5804 15.7424L17.3429 13.5095C16.5438 12.7121 15.1853 13.0311 14.8656 14.0677C14.6259 14.7855 13.8267 15.1842 13.1075 15.0247C11.5093 14.626 9.35166 12.5526 8.95209 10.878C8.71236 10.1602 9.19183 9.36278 9.91104 9.12358C10.9499 8.8046 11.2696 7.44895 10.4704 6.6515L8.23288 4.41866C7.59358 3.86045 6.63464 3.86045 6.07525 4.41866L4.55691 5.9338C3.03858 7.52869 4.71674 11.7551 8.47262 15.5031C12.2285 19.2511 16.4639 21.0055 18.0621 19.4106L19.5804 17.8955C20.1399 17.2575 20.1399 16.3006 19.5804 15.7424Z",
    fill: "#FF8000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8f0c17d66dffec993580cdd9dd2b0bf1.svg";
export { ForwardRef as ReactComponent };